import { render, staticRenderFns } from "./CheckoutProductItems.vue?vue&type=template&id=49a2742f&scoped=true"
import script from "./CheckoutProductItems.vue?vue&type=script&lang=js"
export * from "./CheckoutProductItems.vue?vue&type=script&lang=js"
import style0 from "./CheckoutProductItems.vue?vue&type=style&index=0&id=49a2742f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a2742f",
  null
  
)

export default component.exports